// extracted by mini-css-extract-plugin
module.exports = {"pricePerNight":"styles_pricePerNight__tBAXV","detail":"styles_detail__u4H12 system_captionM__mntHX"};